<ng-container *ngIf="hasForm$ | async">
  <form [formGroup]="form">
    <store-order-form
      #fulfillmentForm
      [orderForms]="orderForm$$ | async"
      [fileUploadUrl]="fileUploadUrl"
      [commonData]="{}"
      [productInfo]="productInfo$$ | async"
      [parentForm]="form"
      [answers]="answers$ | async"
      [extraFields]="[]"
      [extraFieldsAnswers]="[]"
      [orderFormOptions]="{ showOfficeUseQuestions: showOfficeUseQuestions, readOnly: readOnly }"
      [users]="users"
      [businessId]="accountGroupId"
      [hideOrderFormTitle]="true"
      [extraHeaderContent]="extraHeaderContent"
      [bottomActionsContent]="bottomActionsContent"
    ></store-order-form>
  </form>
  <ng-template #bottomActionsContent>
    <div *ngIf="!readOnly" class="button-container">
      <ng-container *ngIf="(formSubmitted$$ | async) === false">
        <button
          mat-flat-button
          color="primary"
          (click)="handleSubmitClicked()"
          data-action="work-order-form-submit-button"
        >
          <glxy-button-loading-indicator [isLoading]="submitLoading$$ | async">
            {{ 'FORM_V2.SUBMIT_FORM' | translate }}
          </glxy-button-loading-indicator>
        </button>

        <button
          mat-stroked-button
          (click)="handleSaveProgressClicked()"
          data-action="work-order-form-save-progress-button"
        >
          <glxy-button-loading-indicator [isLoading]="saveProgressLoading$$ | async">
            {{ 'FORM_V2.SAVE_PROGRESS' | translate }}
          </glxy-button-loading-indicator>
        </button>

        <ng-container *ngIf="extraActionButtons" [ngTemplateOutlet]="extraActionButtons" />
      </ng-container>

      <!-- Form is submitted, all parties can save changes still -->
      <div *ngIf="formSubmitted$$ | async">
        <button
          mat-flat-button
          color="primary"
          (click)="handleSaveChangesClicked()"
          data-action="work-order-form-save-changes"
        >
          <glxy-button-loading-indicator [isLoading]="saveProgressLoading$$ | async">
            {{ 'FORM_V2.SAVE_CHANGES' | translate }}
          </glxy-button-loading-indicator>
        </button>

        <ng-container *ngIf="extraActionButtons" [ngTemplateOutlet]="extraActionButtons" />

        <div *ngIf="(latestSubmission$ | async)?.updated | date: 'medium' as timestamp" class="last-updated">
          {{ 'FORM_V2.LAST_UPDATED' | translate: { timestamp } }}
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
